/**
 * WebsiteOrdersPanel — composer for the chat right-panel "order" tab.
 *
 * Originally a 1,617-line monolith holding the live orders list, place-admin-
 * order form, prefill metadata pills, and per-item cancellation flow all in
 * one file. Feb 2026 code-quality refactor split each concern into its own
 * file:
 *
 *   • `websiteOrdersUtils.jsx`   — shared constants + StatusBadge/Field/formatMoney
 *   • `WebsiteOrdersList.jsx`    — live orders fetched from exoticindia.com
 *   • `PlaceAdminOrderForm.jsx`  — admin-side order creation + AI prefill
 *   • `CancelItemButton.jsx`     — per-line-item cancel + refund (Iter 151)
 *
 * This file keeps the same default export so no consumer (`ChatsPage.jsx`)
 * needed to change.
 */
import { WebsiteOrdersList } from "./WebsiteOrdersList";
import { PlaceAdminOrderForm } from "./PlaceAdminOrderForm";

const WebsiteOrdersPanel = ({ leadId, lead }) => {
  if (!leadId) return null;
  return (
    <div className="border-t border-slate-200 bg-white" data-testid="website-orders-panel">
      <WebsiteOrdersList leadId={leadId} lead={lead} />
      <PlaceAdminOrderForm leadId={leadId} lead={lead} />
    </div>
  );
};

export default WebsiteOrdersPanel;
